// profileExtension.ts
import { clientConnector } from '@games/socket-client'

type ProfileCallback = (error: string | null, response: unknown) => void

/**
 * Расширяет clientConnector для работы с комнатами
 */
export function extendSocketWithRoom(): void {
  // Регистрируем один компонент со всеми методами комнаты
  const roomComponent = {
    name: 'room',
    methods: {
      // Методы для отправки запросов (с ожиданием ответа)
      find: {
        emitEvent: 'room:find:ask',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onFindRoomReceived'
      },
      join: {
        emitEvent: 'room:join:ask',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onJoinRoomReceived'
      },
      fastJoin: {
        emitEvent: 'room:fastJoin',
        expectsResponse: true,
        timeout: 15000,
        responseMethodName: 'onFastJoinRoomReceived'
      },
      leave: {
        emitEvent: 'room:state:leave',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onLeaveRoomReceived'
      },
      confirm: {
        emitEvent: 'room:state:confirm',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onStateConfirmationSent'
      },
      joinAsSpectator: {
        emitEvent: 'room:spectator:join',
        expectsResponse: true,
        timeout: 8000,
        responseMethodName: 'onSpectatorJoinReceived'
      },

      // Методы для прослушивания событий от сервера
      onRoomStateUpdated: {
        listenEvent: 'room:state:onRoomStateUpdated',
        responseMethodName: 'onRoomStateUpdated'
      },
      onOpponentConfirmationReceived: {
        listenEvent: 'room:state:onOpponentConfirmationReceived',
        responseMethodName: 'onOpponentConfirmationReceived'
      },
      onRoomLeaveTimeout: {
        listenEvent: 'room:state:onRoomLeaveTimeout',
        responseMethodName: 'onRoomLeaveTimeout'
      },
      onSpectatorsList: {
        listenEvent: 'room:state:onSpectatorsList',
        responseMethodName: 'onSpectatorsList'
      }
    }
  }
  
  // Регистрируем компонент без возврата результата
  clientConnector.registerComponent(roomComponent);
}